import Flickity from 'flickity';
import formatFreeShippingThresholds from '../../utils/formatFreeShippingThreshold';

const announcements = {};

const announcementInit = (carousel, index) => {
  // Format any free-shipping-threshold placeholders first, before the early
  // return below, so single-announcement bars and theme-editor reloads are covered.
  formatFreeShippingThresholds(carousel);

  const track = carousel.querySelector('[data-announcements-track]');
  if (!track || track.children.length < 2) {
    // Don't init pointless carousels with 1 or no slides
    return;
  }

  const elements = carousel.querySelectorAll('#country-picker');
  elements.forEach((element) => {
    element.remove();
  });
  const id = carousel.parentElement.getAttribute('id');
  announcements[id] = new Flickity(track, {
    initialIndex: index || 0,
    cellSelector: '.Announcement',
    contain: true,
    prevNextButtons: carousel.dataset.prevNextButtons === 'true',
    autoPlay: carousel.dataset.autoPlay,
    dragThreshold: window.theme.flickity.dragThreshold,
    pageDots: false,
    draggable: true,
    wrapAround: true,
    pauseAutoPlayOnHover: true,
    setGallerySize: false,
  });
};

export { announcements, announcementInit };
